import { Module } from 'vuex';
import { deleteResource } from '@/content-library/delete-resource/store/delete-resource.store';
import { IContentLibraryState } from '@/content-library/store/content-library.types';
import { state } from '@/content-library/store/content-library.constants';
import { getters } from '@/content-library/store/content-library.getters';
import { actions } from '@/content-library/store/content-library.actions';
import { mutations } from '@/content-library/store/content-library.mutations';
import { RootState } from '@/store/store';
import { createResource } from '@/content-library/create-resource/store/create-resource.store';
import { templateUsage } from '@/content-library/template-usage/store/template-usage.store';
import { resourceLibrary } from '@/content-library/resource-library/store/resource-library.store';
import { directories } from '@/content-library/directories/store/directory.store';
import { disconnectResource } from '@/content-library/disconnect-resource/store/disconnect-resource.store';
import { moveResource } from '@/content-library/move-resource/store/move-resource.store';
import { search } from '@/content-library/search/store/search.store';

export const contentLibrary: Module<IContentLibraryState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
  modules: {
    createResource,
    deleteResource,
    templateUsage,
    resourceLibrary,
    directories,
    disconnectResource,
    moveResource,
    search,
  },
};
